var map = {
	"./cam-context-switcher-costcenter-list.ejs": 225,
	"./cam-context-switcher-costcenter.ejs": 226,
	"./cam-context-switcher-organization-list.ejs": 227,
	"./cam-context-switcher-organization.ejs": 228,
	"./cam-context-switcher-panel.ejs": 229,
	"./cam-context-switcher-workspace-list.ejs": 230,
	"./cam-context-switcher-workspace.ejs": 231,
	"./cam-context-switcher.ejs": 113
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates ^\.\/.*\.ejs$
// module id = 23
// module chunks = 0